var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _path2, _path3, _polygon, _path4, _path5, _path6, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConverterFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "grafik",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 104",
    enableBackground: "new 0 0 50 104",
    xmlSpace: "preserve",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.3,
    y: 15,
    fill: "#000",
    width: 10.3,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    fill: "#000",
    width: 16.3,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 24.1,
    fill: "#000",
    width: 2,
    height: 13
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 59.5,
    fill: "#000",
    width: 2,
    height: 7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 91,
    fill: "#000",
    width: 2,
    height: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.1,92h-26V66.1H39L39.1,92z M15.1,90h22V68h-22V90z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 62.5,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 63.7004 4.8991)",
    fill: "#000028",
    width: 2,
    height: 33.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.4,73.5c-0.9,0.1-2.2-0.1-3.2-1.5c-0.4-0.6-0.7-0.6-0.9-0.6c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.4,0.1 c-0.2,0.1-0.3,0.4-0.5,0.7l-0.2,0.5l-2,0l0.2-0.5c0.6-1.6,1.8-2.1,2.7-2.3l0,0c0.9-0.1,2.2,0,3.2,1.4c0.5,0.7,0.9,0.5,1.1,0.6 c0.2-0.1,0.6-0.1,0.8-0.8l0.2-0.5l2,0l-0.2,0.5C26.5,72.9,25.3,73.4,24.4,73.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.3,88c-0.9,0.1-2.2-0.1-3.2-1.5c-0.4-0.6-0.7-0.6-0.9-0.6c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.4,0.1 c-0.2,0.1-0.3,0.4-0.5,0.7L27,87.3l-2,0l0.2-0.5c0.6-1.6,1.8-2.1,2.7-2.3l0,0c0.9-0.1,2.2,0,3.2,1.4c0.5,0.7,0.9,0.5,1.1,0.6 c0.2-0.1,0.6-0.1,0.8-0.8l0.2-0.5l2,0l-0.2,0.5C34.4,87.3,33.2,87.9,32.3,88z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "21.9,24.7 21,23 31.3,16 21,9 21.9,7.3 34.8,16 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.1,26c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10C36.1,21.5,31.6,26,26.1,26z M26.1,8 c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C34.2,11.6,30.6,8,26.1,8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.2,53.5v-10h2.2l2.4,6.5c0.2,0.5,0.3,1.1,0.5,1.7c0.1-0.6,0.3-1.1,0.5-1.7l2.1-6.5h2.3v10h-1.5v-7.9 c-0.2,0.7-0.4,1.4-0.6,2.1l-2,5.8h-1.5l-2.2-5.7c-0.2-0.7-0.4-1.4-0.6-2.2v7.9L21.2,53.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.1,48.5c0,6.6-5.4,12-12,12s-12-5.4-12-12s5.4-12,12-12S38.1,41.9,38.1,48.5z M26.1,38.5 c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S31.6,38.5,26.1,38.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "45.1,11 45.1,21 50.1,16 49.1,15 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverterFull);
export default __webpack_public_path__ + "static/media/Converter_Full.6fb06453e00d920ee6db224e4b299522.svg";
export { ForwardRef as ReactComponent };